import React from 'react'
import '@fontsource-variable/manrope'
import './src/styles/global.css'
import AppShell from './src/components/AppShell'

export const wrapRootElement = ({ element }) => (
  <AppShell>{element}</AppShell>
)